import { makeStyles } from '@material-ui/core';
import React from 'react';
import parse from 'html-react-parser';
import { width } from 'dom-helpers';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    },
    descFieldName: {
        fontSize: '24px',
        width: (props) => (props.fullWidth ? '100%' : 'auto'),
        fontWeight: '700',
        whiteSpace: 'nowrap',
        marginRight: '6px',
        color: theme.palette.primary.main,
    },
    descValue: {
        fontSize: '24px',
        whiteSpace: 'pre-wrap',
        lineHeight: '100%',
        marginTop: '5px',
    },
    containerMultiValues: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        flexWrap: 'wrap',
    },
    hasFileAnchorUrl: {
        textDecoration: 'underline !important',
        textDecorationThickness: '1px !important',
        textUnderlineOffset: '2px !important',
    },
    htmlDetail: {
        padding: '0px',
        overflow: 'hidden',
    },
}));

const PublicDetail = (props) => {
    const { fieldName, className, value, isHtml = false, fullWidth } = props;
    const classes = useStyles({ fullWidth });

    if (isHtml) {
        return (
            <div className={`${classes.containerMultiValues} ${className}`}>
                <span className={classes.descFieldName}>
                    {fieldName ? fieldName + ':' : ''}
                </span>
                <span
                    className={`${classes.descValue} ql-editor ${classes.htmlDetail}`}
                >
                    {value && value !== '<p><br></p>' ? parse(value) : '-'}
                </span>
            </div>
        );
    } else {
        return (
            <div className={`${classes.container} ${className}`}>
                <span className={classes.descFieldName}>
                    {fieldName ? fieldName + ':' : ''}
                </span>
                <span className={classes.descValue}>{value ? value : ''}</span>
            </div>
        );
    }
};

export default PublicDetail;
